var jbevents3 = {
    "type": "FeatureCollection",
    "features": [
          {
            "type": "Feature",
            "properties": {
              "week_num": 2,
              "season": "Winter 25'",
              "date": "2025-02-15",
              "name": "Badrutt's Palace Hotel",
              "address": "St. Moritz, Switzerland",
              "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Badrutts_Palace_Hotel_rating.png?v=1743124565",
              "city": "St. Moritz",
              "country": "Switzerland",
              "category": "Grand Hotel",
              "sub-category": "Elevated Escapes",
              "month": "February",
              "collection_name": "World Tour",
              "highlight": "Alpine Elegance & Pet Luxury",
              "experience_description": "Experience timeless Swiss luxury with stunning mountain views and bespoke pet amenities at Badrutt's Palace Hotel. Enjoy world-class service, exquisite dining, and a welcoming atmosphere for you and your four-legged friend.",
              "caption": "Indulge in alpine luxury ❄️🐾",
              "morning": "Begin your day with a gourmet breakfast and a serene lakeside stroll in St. Moritz.",
              "midday": "Indulge in luxury spa treatments and enjoy pet-friendly experiences around the hotel.",
              "afternoon": "Explore the chic boutiques of St. Moritz or take a scenic hike with your furry friend.",
              "evening": "Dine in style at exquisite restaurants while the Alps provide a breathtaking backdrop.",
              "website": "https://www.badruttspalace.com/",
              "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/JB_st_moritz.png?v=1743275522",
              "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fav3.png?v=1743124607",
              "product_link": "https://www.jbthejetsetter.com/products/alpine-escape-in-st-moritz",
              "location": "St. Moritz"
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                9.8381,
                46.4973
              ]
            }
          },                
          {
            "type": "Feature",
            "properties": {
                "week_num": 2,
                "season": "Winter 25'",
                "date": "2025-01-10",
                "name": "Ultima Courchevel Belvédère",
                "address": "Courchevel, France",
                "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Ultima_Courchevel_Belvedere_rating.png?v=1743125329",
                "city": "Courchevel",
                "country": "France",
                "category": "Resort Escapes",
                "sub-category": "Elevated Escapes",
                "month": "February",
                "collection_name": "World Tour",
                "highlight": "Luxury Apr\u00e8s-Ski",
                "experience_description": "Ski the pristine slopes of Courchevel 1850, then toast to Alpine glamour at après-ski lounges with champagne and panoramic mountain views.",
                "caption": "Ski, sip, and soak in the alpine glam \ud83c\udfbf\ud83e\udd42",
                "morning": "Start your day with a luxury breakfast and a scenic morning walk in Courchevel, France.",
                "midday": "Main experience: Luxury apr\u00e8s-ski.",
                "afternoon": "Explore local culture or unwind at Cheval Blanc Courchevel.",
                "evening": "Enjoy a fine dining experience and exclusive nightlife in Courchevel, France.",
                "website": "https://www.chevalblanc.com/en/maison/courchevel/",
                "product_link": "https://jbthejetsetter.com/products/apres-ski-in-courchevel",
                "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/courchevel1.png?v=1740632855",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fav3.png?v=1743124607",
                "location": "Courchevel",
                "average_price": "€1200/night"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.6351,
                    45.4154
                ]
            }
        },

    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-10",
        "name": "Ultima Courchevel Belvédère",
        "address": "Courchevel, France",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Ultima_Courchevel_Belvedere_rating.png?v=1743125329",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_courchevel.png",
        "city": "Courchevel",
        "country": "France",
        "category": "Resort Escapes",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Luxury Après‑Ski",
        "experience_description": "Ski the pristine slopes of Courchevel 1850 then toast to alpine glamour at exclusive après‑ski lounges with champagne and panoramic mountain views.",
        "caption": "Ski, sip, and soak in alpine glam 🎿🐾",
        "morning": "Gourmet breakfast and a scenic mountain walk.",
        "midday": "Upscale après‑ski experiences in style.",
        "afternoon": "Discover local alpine culture or relax at Cheval Blanc Courchevel.",
        "evening": "Fine dining and vibrant nightlife with breathtaking views.",
        "website": "https://www.chevalblanc.com/en/maison/courchevel/",
        "product_link": "https://jbthejetsetter.com/products/apres-ski-in-courchevel",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/courchevel1.png?v=1740632855",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Courchevel",
        "average_price": "€1200/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [6.6351, 45.4154]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-11",
        "name": "The Peninsula Beverly Hills",
        "address": "Beverly Hills, California, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/beverly_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_beverly.png",
        "city": "Beverly Hills",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Iconic Hollywood Glamour with Pet‑Friendly Perks",
        "experience_description": "Experience refined luxury and exclusive pet amenities in the heart of Beverly Hills.",
        "caption": "Hollywood luxury with pet perks",
        "morning": "Elegant breakfast amid lush gardens.",
        "midday": "Relax by a chic pool with dedicated pet service.",
        "afternoon": "Explore upscale shopping with your furry friend.",
        "evening": "Dine under the stars in iconic style.",
        "website": "https://www.peninsula.com/en/beverly-hills",
        "product_link": "https://jbthejetsetter.com/products/beverly-hills-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/beverly1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Beverly Hills",
        "average_price": "$1200/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-118.4065, 34.0736]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-12",
        "name": "Four Seasons Hotel George V, Paris",
        "address": "Paris, France",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paris_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_paris.png",
        "city": "Paris",
        "country": "France",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Parisian Elegance with Unmatched Pet‑Friendly Service",
        "experience_description": "Indulge in timeless luxury and exceptional pet amenities at the Four Seasons Hotel George V.",
        "caption": "Timeless Parisian luxury",
        "morning": "Chic breakfast in an opulent setting.",
        "midday": "Stroll along the Seine with your pet.",
        "afternoon": "Explore haute couture and art galleries.",
        "evening": "Dine in legendary ambiance as Paris sparkles.",
        "website": "https://www.fourseasons.com/paris/",
        "product_link": "https://jbthejetsetter.com/products/paris-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paris1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Paris",
        "average_price": "€1500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [2.3000, 48.8684]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-13",
        "name": "The Ritz-Carlton, Hong Kong",
        "address": "Hong Kong, China",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/hk_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_hk.png",
        "city": "Hong Kong",
        "country": "China",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Sky‑High Luxury & Pet‑Pampering",
        "experience_description": "Enjoy unmatched luxury in the sky with exclusive pet services at The Ritz‑Carlton, Hong Kong.",
        "caption": "Sky‑high luxury in a vibrant city",
        "morning": "Gourmet breakfast with panoramic skyline views.",
        "midday": "Relax in an indulgent spa.",
        "afternoon": "Discover Hong Kong’s dynamic culture with your pet.",
        "evening": "Savor elegant dining with dazzling harbor views.",
        "website": "https://www.ritzcarlton.com/en/hotels/china/hong-kong",
        "product_link": "https://jbthejetsetter.com/products/hk-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/hk1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Hong Kong",
        "average_price": "HK$3500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [114.1825, 22.3029]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-14",
        "name": "The Peninsula New York",
        "address": "New York, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/ny_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_ny.png",
        "city": "New York",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Iconic New York Luxury & Pet‑Friendly Service",
        "experience_description": "Experience timeless elegance and personalized pet amenities at The Peninsula New York.",
        "caption": "Big city luxury with pet perks",
        "morning": "Gourmet breakfast and stunning skyline views.",
        "midday": "Relax in lavish surroundings with pet‑friendly service.",
        "afternoon": "Explore Manhattan with your furry friend.",
        "evening": "Dine in a premier setting as the city lights up.",
        "website": "https://www.peninsula.com/en/new-york",
        "product_link": "https://jbthejetsetter.com/products/ny-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/ny1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1300/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-73.9760, 40.7608]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-15",
        "name": "Mandarin Oriental, Tokyo",
        "address": "Tokyo, Japan",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tokyo_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_tokyo.png",
        "city": "Tokyo",
        "country": "Japan",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Tokyo Elegance & Pet‑Friendly Style",
        "experience_description": "Immerse yourself in modern luxury and refined Japanese hospitality with exclusive pet‑friendly perks at Mandarin Oriental, Tokyo.",
        "caption": "Elegant sophistication in Tokyo",
        "morning": "Sumptuous breakfast with panoramic city views.",
        "midday": "Indulge in world‑class spa treatments.",
        "afternoon": "Explore Tokyo’s vibrant neighborhoods with your pet.",
        "evening": "Exquisite Japanese cuisine in an upscale setting.",
        "website": "https://www.mandarinoriental.com/tokyo",
        "product_link": "https://jbthejetsetter.com/products/tokyo-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tokyo1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Tokyo",
        "average_price": "¥25000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [139.7590, 35.6784]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-16",
        "name": "Park Hyatt Melbourne",
        "address": "Melbourne, Australia",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/melbourne_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_melbourne.png",
        "city": "Melbourne",
        "country": "Australia",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Modern Luxury & Pet‑Friendly Comfort",
        "experience_description": "Experience sophisticated urban luxury and exceptional pet services at Park Hyatt Melbourne in the heart of the city.",
        "caption": "Urban elegance with pet perks",
        "morning": "Artful breakfast with scenic city views.",
        "midday": "Relax in refined comfort and style.",
        "afternoon": "Leisurely stroll through Melbourne’s cultural precincts with your pet.",
        "evening": "Chic dining as the city lights up.",
        "website": "https://www.hyatt.com/en-US/hotel/australia/park-hyatt-melbourne/melh",
        "product_link": "https://jbthejetsetter.com/products/melbourne-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/melbourne1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Melbourne",
        "average_price": "AUD 800/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [144.9631, -37.8136]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-17",
        "name": "The Greenwich Hotel, New York",
        "address": "New York, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/greenwich_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_greenwich.png",
        "city": "New York",
        "country": "USA",
        "category": "Boutique Stay",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Intimate Luxury & Pet‑Friendly Charm",
        "experience_description": "Relish a blend of understated elegance and warm pet‑friendly service at The Greenwich Hotel in New York.",
        "caption": "Boutique luxury in Manhattan",
        "morning": "Cozy breakfast in refined surroundings.",
        "midday": "Explore local art and culture with your pet.",
        "afternoon": "Stroll through charming streets with your furry companion.",
        "evening": "Sophisticated dinner in an intimate setting.",
        "website": "https://www.thegreenwichhotel.com/",
        "product_link": "https://jbthejetsetter.com/products/greenwich-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/greenwich1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-74.0020, 40.7325]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-18",
        "name": "The Langham, New York",
        "address": "New York, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/langham_ny_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_langham_ny.png",
        "city": "New York",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Classic Elegance with Exclusive Pet Perks",
        "experience_description": "Revel in refined luxury and exceptional pet amenities at The Langham, New York.",
        "caption": "Classic urban elegance with pet perks",
        "morning": "Gourmet breakfast with skyline views.",
        "midday": "Relax in plush surroundings with pet‑friendly service.",
        "afternoon": "Stroll through Manhattan’s iconic areas with your pet.",
        "evening": "Savor sophisticated dining as the city sparkles.",
        "website": "https://www.langhamhotels.com/en/the-langham/new-york/",
        "product_link": "https://jbthejetsetter.com/products/ny-langham-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/langham_ny1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1400/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-74.0059, 40.7069]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-19",
        "name": "The Pierre, A Taj Hotel, New York",
        "address": "New York, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/pierre_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_pierre.png",
        "city": "New York",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Opulent Elegance & Pet‑Friendly Service",
        "experience_description": "Experience timeless sophistication and exceptional pet amenities at The Pierre, a landmark of New York luxury.",
        "caption": "Opulent elegance in a landmark setting",
        "morning": "Gourmet breakfast in a historic ambiance.",
        "midday": "Relax in an elegant lounge with pet‑friendly perks.",
        "afternoon": "Enjoy an exclusive stroll along Central Park with your pet.",
        "evening": "Dine in a classic New York setting.",
        "website": "https://www.thepierreny.com/",
        "product_link": "https://jbthejetsetter.com/products/pierre-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/pierre1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1600/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-73.9740, 40.7651]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-20",
        "name": "The Ritz-Carlton, Los Angeles",
        "address": "Los Angeles, California, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/la_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_la.png",
        "city": "Los Angeles",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Hollywood Glamour & Pet‑Friendly Luxury",
        "experience_description": "Relish refined luxury with sweeping city views and impeccable pet services at The Ritz‑Carlton, Los Angeles.",
        "caption": "Hollywood glamour meets pet‑friendly luxury",
        "morning": "Gourmet breakfast with panoramic cityscapes.",
        "midday": "Relax by an opulent pool with dedicated pet service.",
        "afternoon": "Explore exclusive Beverly Hills locales with your pet.",
        "evening": "Experience sophisticated dining under the stars.",
        "website": "https://www.ritzcarlton.com/en/hotels/los-angeles",
        "product_link": "https://jbthejetsetter.com/products/la-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/la1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Los Angeles",
        "average_price": "$1200/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-118.4004, 34.0453]
      }
    },

    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-22",
        "name": "The Ritz-Carlton, Lake Tahoe",
        "address": "Lake Tahoe, California, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tahoe_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_tahoe.png",
        "city": "Lake Tahoe",
        "country": "USA",
        "category": "Resort Escapes",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Mountain Majesty & Pet‑Friendly Adventure",
        "experience_description": "Escape to the alpine splendor of Lake Tahoe with luxurious amenities and outstanding pet services at The Ritz‑Carlton, Lake Tahoe.",
        "caption": "Alpine adventure with refined luxury",
        "morning": "Breakfast with panoramic mountain views.",
        "midday": "Ski or relax in the spa with pet‑friendly care.",
        "afternoon": "Explore snowy trails with your pet.",
        "evening": "Dine as the mountains glow at sunset.",
        "website": "https://www.ritzcarlton.com/en/hotels/lake-tahoe",
        "product_link": "https://jbthejetsetter.com/products/lake-tahoe-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tahoe1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Lake Tahoe",
        "average_price": "$900/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-120.0324, 39.0968]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-23",
        "name": "The Chatwal, New York",
        "address": "New York, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/chatwal_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_chatwal.png",
        "city": "New York",
        "country": "USA",
        "category": "Boutique Stay",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Boutique Luxury & Tail‑Wagging Charm",
        "experience_description": "Experience intimate, artful luxury with warm pet‑friendly service at The Chatwal in New York.",
        "caption": "Boutique charm with pet perks",
        "morning": "Creative breakfast in a stylish setting.",
        "midday": "Discover curated art exhibits.",
        "afternoon": "Stroll through Manhattan’s hidden treasures with your pet.",
        "evening": "Savor an intimate dinner in elegant ambiance.",
        "website": "https://www.thechatwalny.com/",
        "product_link": "https://jbthejetsetter.com/products/chatwal-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/chatwal1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1700/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-73.9880, 40.7527]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-24",
        "name": "The Ritz-Carlton, Tokyo",
        "address": "Tokyo, Japan",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tokyo_ritz_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_tokyo_ritz.png",
        "city": "Tokyo",
        "country": "Japan",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Ultra‑Modern Luxury in the Heart of Tokyo",
        "experience_description": "Experience cutting‑edge sophistication and premium pet amenities at The Ritz‑Carlton, Tokyo.",
        "caption": "Ultra‑modern elegance in Tokyo",
        "morning": "Lavish breakfast with skyline views.",
        "midday": "Indulge in top‑tier spa treatments.",
        "afternoon": "Explore Tokyo’s vibrant urban scene with your pet.",
        "evening": "Dine in style with unparalleled service.",
        "website": "https://www.ritzcarlton.com/en/hotels/japan/tokyo",
        "product_link": "https://jbthejetsetter.com/products/tokyo-ritz-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tokyo_ritz1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Tokyo",
        "average_price": "¥28000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [139.7300, 35.6700]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-25",
        "name": "The Four Seasons Hotel, New York Downtown",
        "address": "New York, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/nydowntown_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_nydowntown.png",
        "city": "New York",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Contemporary Luxury & Tail‑Wagging Service",
        "experience_description": "Discover modern sophistication and exclusive pet‑friendly amenities at Four Seasons Hotel, New York Downtown.",
        "caption": "Contemporary luxury with pet perks",
        "morning": "Stylish breakfast with urban views.",
        "midday": "Relax in sleek, upscale surroundings.",
        "afternoon": "Explore the dynamic cityscape with your pet.",
        "evening": "Experience exceptional dining and service.",
        "website": "https://www.fourseasons.com/newyorkdowntown/",
        "product_link": "https://jbthejetsetter.com/products/nydowntown-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/nydowntown1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1900/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-74.0113, 40.7050]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-26",
        "name": "The St. Regis Beverly Hills",
        "address": "Beverly Hills, California, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/stregis_bh_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_stregisbh.png",
        "city": "Beverly Hills",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Timeless Glamour & Exclusive Pet Services",
        "experience_description": "Enjoy iconic luxury, exceptional service, and outstanding pet amenities at The St. Regis Beverly Hills.",
        "caption": "Iconic Beverly Hills luxury",
        "morning": "Elegant breakfast amid lush surroundings.",
        "midday": "Chic poolside relaxation with pet service.",
        "afternoon": "Explore upscale neighborhoods with your pet.",
        "evening": "Sophisticated dining with stellar service.",
        "website": "https://www.marriott.com/hotels/travel/laxst-the-st-regis-beverly-hills/",
        "product_link": "https://jbthejetsetter.com/products/stregis-beverly-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/stregis_bh1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Beverly Hills",
        "average_price": "$2000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-118.4060, 34.0730]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-27",
        "name": "Aman Tokyo",
        "address": "Tokyo, Japan",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/aman_tokyo_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_amantokyo.png",
        "city": "Tokyo",
        "country": "Japan",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Exclusive Japanese Tranquility & Pet‑Friendly Service",
        "experience_description": "Discover understated luxury and exceptional pet hospitality at Aman Tokyo, an intimate urban sanctuary.",
        "caption": "Exquisitely serene in Tokyo",
        "morning": "Elegant breakfast with peaceful views.",
        "midday": "Relax in a minimalist spa setting.",
        "afternoon": "Explore quiet Tokyo neighborhoods with your pet.",
        "evening": "Dine in a serene blend of tradition and modernity.",
        "website": "https://www.aman.com/resorts/aman-tokyo",
        "product_link": "https://jbthejetsetter.com/products/aman-tokyo-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/aman_tokyo1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Tokyo",
        "average_price": "¥30000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [139.7528, 35.6804]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-28",
        "name": "Belmond Hotel Caruso, Ravello",
        "address": "Ravello, Italy",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/caruso_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_caruso.png",
        "city": "Ravello",
        "country": "Italy",
        "category": "Boutique Stay",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Dramatic Cliff‑Side Luxury & Pet‑Friendly Views",
        "experience_description": "Perched high above the Amalfi Coast, Belmond Hotel Caruso offers breathtaking views, exquisite design, and warm pet‑friendly service.",
        "caption": "Boutique cliff‑side luxury",
        "morning": "Enjoy an alfresco breakfast with stunning coastal views.",
        "midday": "Relax in a serene courtyard with your pet.",
        "afternoon": "Explore the charming town of Ravello.",
        "evening": "Dine in a romantic setting overlooking the Mediterranean.",
        "website": "https://www.belmond.com/hotels/europe/italy/belmond-hotel-caruso-ravello/",
        "product_link": "https://jbthejetsetter.com/products/ravello-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/caruso1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Ravello",
        "average_price": "€1700/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [14.6100, 40.6333]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 2,
        "season": "Winter 25'",
        "date": "2025-01-29",
        "name": "Six Senses Zighy Bay",
        "address": "Zighy Bay, Oman",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/zighybay_rating.png",
        "jb_rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jb_rating_zighybay.png",
        "city": "Zighy Bay",
        "country": "Oman",
        "category": "Resort Escapes",
        "sub-category": "Elevated Escapes",
        "month": "February",
        "collection_name": "World Tour",
        "highlight": "Secluded Luxury Amid Rugged Coastlines",
        "experience_description": "Nestled in a remote corner of Oman, Six Senses Zighy Bay offers a unique blend of luxury, adventure, and pet‑friendly escapes.",
        "caption": "Remote luxury with dramatic coastal views",
        "morning": "Savor a beachside breakfast with rugged vistas.",
        "midday": "Unwind with spa treatments in a natural setting.",
        "afternoon": "Embark on an adventurous coastal excursion with your pet.",
        "evening": "Dine under the stars by the sea.",
        "website": "https://www.sixsenses.com/en/resorts/zighy-bay",
        "product_link": "https://jbthejetsetter.com/products/zighybay-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/zighybay1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Zighy Bay",
        "average_price": "$1500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [56.2400, 23.0200]
      }
    }
    ,
                          {
            "type": "Feature",
            "properties": {
                "star": "5 Star Hotel",
                "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/aman_rating.png?v=1743137987",
                "week_num": 1,
                "date": "2025-02-02",
                "season": "Winter 25'",
                "name": "Amangiri",
                "address": "1 Kayenta Road, Canyon Point, Utah 84741, USA",
                "city": "Canyon Point, Utah",
                "country": "USA",
                "category": "Resort Escapes",
                "sub-category": "Scenic Stays",
                "month": "February",
                "collection_name": "celebration",
                "highlight": "A secluded luxury resort in the heart of the Utah desert, offering world-class spa treatments, private guided hikes, and unparalleled stargazing.",
                "experience_description": "Wake up to breathtaking desert landscapes, unwind in a private plunge pool, and explore slot canyons with expert guides. Amangiri is a masterpiece of minimalism and tranquility, blending seamlessly with the surrounding sandstone cliffs.",
                "caption": "Canyon dreams",
                "morning": "Start your day with a sunrise yoga session overlooking the mesas, followed by a gourmet breakfast on your private terrace.",
                "midday": "Indulge in a rejuvenating desert-inspired spa treatment, or embark on a private guided hike through the slot canyons.",
                "afternoon": "Float in the stunning rock-framed pool while sipping signature cocktails, or take a scenic hot-air balloon ride over the breathtaking Utah landscape.",
                "evening": "Dine under the stars with a private chef-curated tasting menu, featuring locally sourced ingredients and fine wine.",
                "website": "https://www.aman.com/resorts/amangiri",
                "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/utah1.png?v=1741074474",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fav3.png?v=1743124607",
                "product_link": "https://jbthejetsetter.com/products/cruisin-through-canyon-dreams-in-utah",

               
            },
            "geometry": {
                "type": "Point",
                "coordinates": [-111.6111,
                    37.0275]
            }
        } , 
      {
  "type": "Feature",
  "properties": {
    "week_num": 2,
    "season": "Summer 25'",
    "date": "2025-06-15",
    "name": "Grand‐Hôtel du Cap‐Ferrat, A Four Seasons Hotel",
    "address": "Avenue du Cap Ferrat, 06230 Saint-Jean-Cap-Ferrat, France",
    "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capferrat_rating.png",
    "city": "Saint-Jean-Cap-Ferrat",
    "country": "France",
    "category": "Resort Escapes",
    "sub-category": "Elevated Escapes",
    "month": "June",
    "collection_name": "World Tour",
    "highlight": "Luxury & Exclusive Heliport Transfers",
    "experience_description": "Experience unparalleled luxury at Grand‐Hôtel du Cap‐Ferrat, a prestigious elevated escape complete with a helipad for private helicopter transfers, exquisite dining, and impeccable service.",
    "caption": "Luxury elevated escape with private helicopter transfers",
    "morning": "Savor a gourmet breakfast on a terrace with breathtaking Mediterranean views.",
    "midday": "Indulge in a rejuvenating spa treatment and poolside relaxation.",
    "afternoon": "Opt for an exclusive helicopter tour over the French Riviera.",
    "evening": "Dine in world-class restaurants while enjoying panoramic sunset views.",
    "website": "https://www.fourseasons.com/capferrat/",
    "product_link": "https://jbthejetsetter.com/products/elevated-escape-cap-ferrat",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capferrat1.png?v=example",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fav_icon.png?v=example",
    "location": "Saint-Jean-Cap-Ferrat",
    "average_price": "€1000 per night"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      7.310969,
      43.701524
    ]
  }
},

      {
  "type": "Feature",
  "properties": {
    "week_num": 3,
    "season": "Summer 25'",
    "date": "2025-07-15",
    "name": "Hôtel Cap Estel",
    "address": "63 Chemin du Cap, 06210 Èze, France",
    "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capestel_rating.png?v=1",
    "city": "Èze",
    "country": "France",
    "category": "Resort Escapes",
    "sub-category": "Elevated Escapes",
    "average_price": "$1200",
    "highlight": "Luxury Escape with Private Heliport",
    "experience_description": "Experience exclusive luxury at Hôtel Cap Estel with a private heliport for swift transfers. Enjoy breathtaking Mediterranean views, gourmet dining, and pet-friendly amenities.",
    "caption": "Elevated Escape with a Heliport & Dog-Friendly Service",
    "morning": "Start with a gourmet breakfast and a stroll along the clifftop overlooking the sea.",
    "midday": "Relax by the infinity pool and enjoy bespoke spa treatments.",
    "afternoon": "Take a helicopter tour of the French Riviera or explore the charming village of Èze.",
    "evening": "Dine under the stars with exquisite regional cuisine.",
    "website": "https://www.capestel.com",
    "product_link": "https://jbthejetsetter.com/products/hotel-cap-estel-elevated-escape",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capestel_image.png?v=1",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/heli_icon.png?v=1",
    "location": "Èze, France",
    "dog_friendly": true,
    "has_heliport": true
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      7.3270,
      43.7230
    ]
  }
},
  ]
}